// components/features/agents/AgentList.tsx
import React from "react";
import AgentRow from "./AgentRow";
import { Agent } from "../../../types/features/Agent";
import TableList, { SelectAction } from "../../ui/TableList";

interface AgentListProps {
  agents: Agent[];
  onAction: (agent: Agent) => void;
  onSelectAgents?: (selectedAgents: Agent[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
  
}

export default function AgentList({
  agents,
  onAction,
  onSelectAgents,
  selectable = false,
  selectActions,

}: AgentListProps) {
  const columns = [
    { header: "Agent", className: "w-2/5" },
    { header: "Contact", className: "hidden sm:table-cell w-1/5" },
    { header: "Département", className: "hidden md:table-cell w-1/6" },
    { header: "Date d'ajout", className: "hidden lg:table-cell w-1/6" },
    { header: "Statut", className: "w-1/6" },
  ];

  return (
    <TableList
      items={agents}
      columns={columns}
      getId={(agent) => agent.id}
      onAction={onAction}
      onSelectItems={onSelectAgents}
      selectable={selectable}
      emptyMessage="Aucun agent trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(agent, isSelected, onSelect) => (
        <AgentRow
          key={agent.id}
          agent={agent}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
       
        />
      )}
    />
  );
}